import React from 'react';

/**
 * Componente: TermsOfServicePage (/pages/TermsOfServicePage.jsx)
 * Página dos Termos de Uso
 */
const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Termos de Uso</h1>
        
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar a plataforma Barberize, você concorda com estes Termos de Uso. 
              Se você não concorda com algum termo, não utilize nossos serviços.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">2. Descrição do Serviço</h2>
            <p>
              A Barberize é uma plataforma de agendamento online que conecta clientes e barbearias. 
              Oferecemos:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Sistema de agendamento de horários</li>
              <li>Gerenciamento de barbearias e serviços</li>
              <li>Notificações por e-mail</li>
              <li>Integração com Google Calendar</li>
              <li>Perfis de usuário (Cliente e Dono de Barbearia)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">3. Cadastro e Conta de Usuário</h2>
            <p>Para usar nossos serviços, você deve:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Fornecer informações verdadeiras e atualizadas</li>
              <li>Manter a confidencialidade de sua senha</li>
              <li>Ser responsável por todas as atividades em sua conta</li>
              <li>Notificar-nos imediatamente sobre uso não autorizado</li>
              <li>Ter pelo menos 18 anos ou consentimento dos responsáveis</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">4. Responsabilidades do Usuário</h2>
            <p>Você concorda em:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Usar a plataforma apenas para fins legais</li>
              <li>Não publicar conteúdo ofensivo, ilegal ou inadequado</li>
              <li>Não tentar acessar áreas restritas do sistema</li>
              <li>Não usar a plataforma para spam ou fraudes</li>
              <li>Respeitar os direitos de outros usuários</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">5. Agendamentos</h2>
            <p><strong>Para Clientes:</strong></p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Agendamentos estão sujeitos à confirmação do dono da barbearia</li>
              <li>Cancelamentos devem ser feitos com antecedência</li>
              <li>Você receberá notificações por e-mail sobre status do agendamento</li>
            </ul>
            <p className="mt-3"><strong>Para Donos de Barbearia:</strong></p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Você é responsável por confirmar ou recusar agendamentos</li>
              <li>Deve manter horários e serviços atualizados</li>
              <li>Cancelamentos devem ser comunicados aos clientes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">6. Integração com Google Calendar</h2>
            <p>
              Ao conectar sua conta do Google Calendar:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Você autoriza a Barberize a criar, editar e excluir eventos no seu calendário</li>
              <li>A sincronização é automática para agendamentos confirmados</li>
              <li>Você pode desconectar a qualquer momento</li>
              <li>Não nos responsabilizamos por conflitos de horários externos</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">7. Pagamentos</h2>
            <p>
              Atualmente, a Barberize não processa pagamentos online. Os pagamentos devem 
              ser acordados diretamente entre cliente e barbearia. A plataforma não se 
              responsabiliza por transações financeiras realizadas fora do sistema.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">8. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo da plataforma (design, código, logos, textos) é propriedade 
              da Barberize e protegido por leis de direitos autorais. Você não pode:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Copiar, modificar ou distribuir nosso código ou design</li>
              <li>Usar nossa marca sem autorização</li>
              <li>Fazer engenharia reversa da plataforma</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">9. Limitação de Responsabilidade</h2>
            <p>
              A Barberize não se responsabiliza por:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Qualidade dos serviços prestados pelas barbearias</li>
              <li>Cancelamentos ou não comparecimentos</li>
              <li>Perda de dados devido a problemas técnicos</li>
              <li>Interrupções temporárias do serviço</li>
              <li>Conflitos entre clientes e barbearias</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">10. Suspensão e Cancelamento</h2>
            <p>
              Reservamo-nos o direito de suspender ou cancelar sua conta se:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Você violar estes Termos de Uso</li>
              <li>Houver atividade suspeita ou fraudulenta</li>
              <li>Você solicitar o cancelamento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">11. Modificações dos Termos</h2>
            <p>
              Podemos modificar estes Termos de Uso a qualquer momento. Notificaremos 
              sobre mudanças significativas. O uso contínuo da plataforma após as mudanças 
              constitui aceitação dos novos termos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">12. Lei Aplicável</h2>
            <p>
              Estes Termos são regidos pelas leis brasileiras. Quaisquer disputas serão 
              resolvidas no foro da comarca de Juiz de Fora, Minas Gerais.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">13. Contato</h2>
            <p>
              Para dúvidas ou questões sobre estes Termos, entre em contato:
            </p>
            <ul className="list-none mt-2 space-y-1">
              <li><strong>E-mail:</strong> barberizeapp01@gmail.com</li>
              <li><strong>WhatsApp:</strong> (32) 99905-2029</li>
            </ul>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-300 text-sm text-gray-600">
            <p><strong>Última atualização:</strong> 20 de novembro de 2025</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsOfServicePage;
